import Prozessauslegung from './Prozessauslegung';
export default Prozessauslegung;
